// The App Store storefront this install belongs to (ART-346), from the wrapper's in-app `Storefront` plugin
// (StorefrontPlugin.swift). The app's "Apply online" passes it to the web application form, which shows prices only
// for the US storefront — Apple's link-out rule depends on the storefront, not on where the phone is.
import { Capacitor, registerPlugin } from "@capacitor/core";

interface StorefrontPlugin {
  get(): Promise<{ countryCode?: string }>;
}

const Storefront = registerPlugin<StorefrontPlugin>("Storefront");

/**
 * The storefront's ISO 3166-1 alpha-3 country code ("USA"), or null: on web, on Android, when StoreKit has no
 * answer, or in a wrapper too old to carry the plugin. Callers treat null as "not the US".
 */
export async function getStorefrontCountry(): Promise<string | null> {
  if (!Capacitor.isNativePlatform() || Capacitor.getPlatform() !== "ios") return null;
  try {
    const { countryCode } = await Storefront.get();
    return countryCode ? countryCode.toUpperCase() : null;
  } catch {
    return null; // an older wrapper without the plugin rejects "not implemented"
  }
}
